import { FETCH_TEMPLATE } from "../actions/types";

export const templateReducer = (state = {}, action) => {
  switch (action.type) {
    case FETCH_TEMPLATE:
      return action.payload;
    default:
      return state;
  }
};
